import React from 'react';


class Footer extends React.Component {
  render() {
    return (
      <footer className="footer text-center">
        Maintained by{' '}
        <a href="https://uditsolutions.in">UD IT Solutions</a>.
      </footer>
    );
  }
}
export default Footer;
